<template>
  <div class="role-edit">
    <FormInfo :formData="formData" :isEdit="true"></FormInfo>
  </div>
</template>

<script>
import FormInfo from "./role-form";

import {_roleSingleInfo} from '@/api/role'

export default {
  data() {
    return {
      formData:{}
    };
  },
  created() {
    // console.log(this.$route.params.id)
    this.roleSingleInfo();
  },
  components: {
    FormInfo
  },
  methods: {
    roleSingleInfo(){
      _roleSingleInfo({
        params:{
          id:this.$route.params.id
        }
      }).then(res=>{
        if(res.resultCode==1){
          this.formData=res.result;
        }else{
          this.$message.error(res.errorMsg);         
        }
      })
    },
  }
};
</script>

<style lang="less" scoped>
</style>